import React from 'react';
import { observer } from 'mobx-react';
import VocabularyThemeListService from '../services/VocabularyThemeListService';
import VocabularyThemeListFilter from './VocabularyThemeListFilter';

const VocabularyThemeListFilterContainer = () => (
  <VocabularyThemeListFilter
    value={VocabularyThemeListService.filter}
    onChange={VocabularyThemeListService.handleFilterChange}
  />
);

export default observer(VocabularyThemeListFilterContainer);
